module.exports = __webpack_public_path__ + "static/epm-hero-bg-1e9c8756ae9533b336c3800377704983.jpg";